import React from "react";
import { ContentBlock } from "@/types/case-study";

interface GalleryBlockProps {
  block: ContentBlock;  
}

export const GalleryBlock: React.FC<GalleryBlockProps> = ({ block }) => {
  const images = block.content?.images || [];

  return (
    <div className="grid md:grid-cols-2 gap-4">
      {images.map((image: any, index: number) => (
        <div key={index} className="relative group/image">
          <div className="w-full bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center p-2 md:p-6">
            <img
              src={image.url}
              alt={image.caption || `Gallery image ${index + 1}`}
              className="shadow-[0_0_14px_-1px_rgba(15,23,42,0.16)] w-auto h-auto max-w-full max-h-[450px] object-contain"
            />
          </div>
        </div>
      ))}
    </div>
  );
};